
import React from "react";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import useDebouncedEffect from "../../hoc/useDebouncedEffect";
import { getUser } from "../../utils/localStorage";

import api from "../../utils/api";

import { toast } from "react-toastify";
import Spinner from "../../common/Spinner/Spinner";

import { useLocation } from "react-router-dom";
import UserDetailContainer from "./UserDetailContainer";
import JpmcThreeSixtyDegreeModalProfile from "./JpmcThreeSixtyDegreeModalProfile";
import JpmcThreeSixtyDegreeModalProfilePage from "./JpmcThreeSixtyDegreeModalProfilePage";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function JpmcThreeSixtyDegreeViewContainer(props) {
    const params = useQuery();
    const [isLoading, setIsLoading] = useState(false);

    const [searchTerm, setSearchTerm] = useState();
    const [userProfileDetail, setUserProfileDetail] = useState([]); // user basic profile details along with business info
    const [totalUsers, setTotalUsers] = useState([]);

    const [userResourcesCount, setUserResourcesCount] = useState(null)
    const [resourcesDetails, setResourcesDetails] = useState(null);

    //User Profile
    const [isOpenUserModal, setIsOpenUserModal] = useState(false);

    //
    const [isPersonaFormOpen, setIsPersonaFormOpen] = useState(false);
    const [selectedResourceInstanceId, setSelectedResourceInstanceId] = useState(null);
    const [showNewSection, setShowNewSection] = useState(false);
    const [newTab, setNewTab] = useState(0);
    const [tab, setTab] = useState(0);

    const [isFormOpen, setIsFormOpen] = useState(false); // persona formopen state

    // states and functions for testimonials
    const [addedTestimonials, setAddedTestimonials] = useState(null);
    const [hasJpmcAddEditPower, setHasJpmcAddEditPower] = useState(null);


    useEffect(() => {
        getAllUserPersonaFile();
        getUserTestimonial();

        const userData = getUser();
        const hasJpmcModelPower = userData?.role?.includes(19);
        setHasJpmcAddEditPower(hasJpmcModelPower);
    }, [])




    useEffect(() => {
        if (userProfileDetail.length > 0) {
            setIsLoading(true)
            getUserResourceCount(userProfileDetail[0]["sMobile"]);
            getResourcesDetails(userProfileDetail[0]["sMobile"]);
            getUserPersonaDetails(userProfileDetail[0]["sMobile"])
            console.log(">>>>below is downloadUserPersonaDetails calling");
            downloadUserPersonaDetails(userProfileDetail[0]["sMobile"]);
            setShowModal(false)
            setSearchTerm("")
        }
    }, [userProfileDetail])
    //=========== getting user details on search ==========
    const onSearchClicked = () => {
        if (searchTerm) {
            getUserProfile(searchTerm);
        } else {
            setUserProfileDetail([])
            setUserResourcesCount(null);
            setSelectedUser(null);
            setShowModal(false);
            setResourcesDetails(null);
            setUserPersonaDetailsAllResources(null);

            setUserGroupKnowledgeSessionPersonaDetails([])
            setUserExptConsultPersonaDetails([])
            setUserCompliancePersonaDetails([])
            setUserMarketConnectPersonaDetails([])
            setUserLoanReadinessPersonaDetails([])
            setUserDigitalEnablementPersonaDetails([])
            setIsFormOpen(false);
        }
    };


    const getUserProfile = (mob) => {
        if (mob) {
            // initially sab previous data back to default kr do
            setIsLoading(true)
            setUserProfileDetail([])
            setUserResourcesCount(null);
            setSelectedUser(null);
            setShowModal(false);
            setResourcesDetails(null);
            setUserPersonaDetailsAllResources(null);
            setIsFormOpen(false);

            setUserGroupKnowledgeSessionPersonaDetails([])
            setUserExptConsultPersonaDetails([])
            setUserCompliancePersonaDetails([])
            setUserMarketConnectPersonaDetails([])
            setUserLoanReadinessPersonaDetails([])
            setUserDigitalEnablementPersonaDetails([])
            setUserPersonaDetailFile("")
            setNewTab(0)
            setTab(0)
            setShowNewSection(false)

            // then get the new data again
            getUserProfileDetail(mob);
            getUserTestimonial(mob);
        }
    }

    const handleSearchInputChange = ({ target }) => {
        const { value } = target;
        setSearchTerm(value);
    };
    ////////////////////////////////////////////////////

    //========= Open modal on profile click ===============//
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null); // Selected user detail object, same data as userProfileDetail

    const user = {
        entryId: 2416,
        name: "Manisha Lahade",
        contact: "7020967361",
        email: "smitenterprices@gmail.com",
        doj: "05/01/2025",
        gender: "Female",
        age: 31,
    };

    const openUserDetailModal = (userId) => {
        console.log(userId, ">>>>>userId");

        const selected = userProfileDetail.find(u => u.Id === userId);

        setShowModal(!showModal);
        if (selected) {
            setSelectedUser(selected);
        }
    };

    // Getting user profile details
    const getUserProfileDetail = async (mobile) => {
        try {
            setIsLoading(true)
            let profileDetail = await api.jpmcThreeSixtyDegreeViewGetUserDetail(mobile)
            console.log(profileDetail, ">>>>profileDetail on api call");
            if (profileDetail.data.length > 0) {
                setUserProfileDetail(profileDetail?.data)
            } else {
                setIsLoading(false)
                setUserProfileDetail([])
                setUserResourcesCount(null);
                setSelectedUser(null);
                setShowModal(false);
                setResourcesDetails(null);
                setUserPersonaDetailsAllResources(null);
                setIsFormOpen(false);

                setUserGroupKnowledgeSessionPersonaDetails([])
                setUserExptConsultPersonaDetails([])
                setUserCompliancePersonaDetails([])
                setUserMarketConnectPersonaDetails([])
                setUserLoanReadinessPersonaDetails([])
                setUserDigitalEnablementPersonaDetails([])
                setSearchTerm("")
                setUserPersonaDetailFile(null)
            }
        } catch (err) {
            console.log(err, ">>>>errorrr")
            toast(String(err?.response?.data?.message), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setIsLoading(false)
            setUserProfileDetail([])
            setUserResourcesCount(null);
            setSelectedUser(null);
            setShowModal(false);
            setResourcesDetails(null);
            setUserPersonaDetailsAllResources(null);
            setIsFormOpen(false);

            setUserGroupKnowledgeSessionPersonaDetails([])
            setUserExptConsultPersonaDetails([])
            setUserCompliancePersonaDetails([])
            setUserMarketConnectPersonaDetails([])
            setUserLoanReadinessPersonaDetails([])
            setUserDigitalEnablementPersonaDetails([])
            setSearchTerm("")
            setUserPersonaDetailFile("")
        }
    }

    // Getting user testimonials
    const getUserTestimonial = async (mobile) => {
        console.log(">>>>userTestimonials called");
        
        setIsLoading(true);
        try {
            const userTestimonials = await api.getUserTestimonial(mobile);
            console.log(userTestimonials, ">>>>userTestimonials");

            if (userTestimonials) {
                const seperatingPersonaDetails = userTestimonials?.data?.data.map((user) => {
                    const { persona_details } = user;

                    let allFieldNames = persona_details.map((persona) => {
                        const { field_name, field_value } = persona;
                        user[field_name] = field_value
                    })

                    return user;
                })

                setAddedTestimonials(seperatingPersonaDetails[0])
            }

            setIsLoading(false);
        } catch (err) {
            toast(String("Error getting testimonials"), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setIsLoading(false);
        }
    }

    // Getting users resource count function
    const getUserResourceCount = async (mob) => {
        setIsLoading(true)
        try {
            if (mob) {
                const result = await api.jpmcThreeSixtyDegreeViewGetResourceCount(mob);
                setUserResourcesCount(result.data)
                setIsLoading(false)

            } else {
                setIsLoading(false)
                throw new Error("Failed to get user resource count")
            }
        } catch (err) {
            console.error(err.message)
            setIsLoading(false)
        }

    }

    // Getting Resource Detailed By User
    const [uniqueGroupKnowledgeInstanceId, setUniqueGroupKnowledgeInstanceId] = useState([]);
    const [uniqueExpertConsultInstanceId, setUniqueExpertConsultInstanceId] = useState([]);
    const [uniqueMarketOppInstanceId, setUniqueMarketOppInstanceId] = useState([]);
    const [uniqueComplianceInstanceId, setUniqueComplianceInstanceId] = useState([]);
    const [uniqueLoandReadinessInstanceId, setUniqueLoanReadinessInstanceId] = useState([]);
    const [uniqueDigitalEnablementInstanceId, setUniqueDigitalEnablementInstanceId] = useState([]);
    const [digitalEnablementInstances, setDigitalEnablementInstances] = useState([]);


    const extractInstanceIdFromReources = (resources) => {
        let allInstIds = resources.map((item) => {
            const { nResourceInstanceId, ...rest } = item;

            return nResourceInstanceId;
        })

        return allInstIds;
    }
    const extractInstanceIdFromResourceName = (resources) => {
        let allInstIds = resources.map((item) => {
            const { nResourceInstanceId,sResourceDisplayName, ...rest } = item;

            return {nResourceInstanceId: nResourceInstanceId, sResourceDisplayName: sResourceDisplayName};
        })

        return allInstIds;
    }

    const getResourcesDetails = async (mob) => {
        setIsLoading(true)
        try {
            if (mob) {
                const result = await api.jpmcThreeSixtyDegreeViewGetResourceDetailedByUser(mob);
                setResourcesDetails(result.data);

                // handling setting of unique resource instanceids for all categories
                console.log(result.data, ">>>>>result.data resourceDetails");

                const { KnowledgeSessions, ExpertConsultations, MarketOpportunities, Compliances, LoanReadiness, Deigital: DigitalEnablement } = result.data;

                let groupKnowledgeInstIdArr = extractInstanceIdFromReources(KnowledgeSessions);
                let expertConsultInstIdArr = extractInstanceIdFromReources(ExpertConsultations);
                let marketOppInstIdArr = extractInstanceIdFromReources(MarketOpportunities);
                let complianceInstIdArr = extractInstanceIdFromReources(Compliances);
                let loanReadinessInstIdArr = extractInstanceIdFromReources(LoanReadiness);
                let digitalEnablementInstIdArr = extractInstanceIdFromReources(DigitalEnablement);
                const separateData = extractInstanceIdFromResourceName(DigitalEnablement)

                setUniqueGroupKnowledgeInstanceId(groupKnowledgeInstIdArr)
                setUniqueExpertConsultInstanceId(expertConsultInstIdArr)
                setUniqueMarketOppInstanceId(marketOppInstIdArr)
                setUniqueComplianceInstanceId(complianceInstIdArr)
                setUniqueLoanReadinessInstanceId(loanReadinessInstIdArr)
                setUniqueDigitalEnablementInstanceId(digitalEnablementInstIdArr)
                setDigitalEnablementInstances(separateData);

                setIsLoading(false)
            } else {
                setIsLoading(false)
                throw new Error("Failed to get user resource count")
            }
        } catch (err) {
            console.error(err.message)
            setIsLoading(false)
        }
    }

    // Getting persona details of the user
    const [userPersonaDetailsAllResources, setUserPersonaDetailsAllResources] = useState();
    const [userGroupKnowledgeSesssionPersonaDetails, setUserGroupKnowledgeSessionPersonaDetails] = useState([]);
    const [userExptConsultationPersonaDetails, setUserExptConsultPersonaDetails] = useState([]);
    const [userCompliancePersonalDetails, setUserCompliancePersonaDetails] = useState([]);
    const [userMarketConnectPersonaDetails, setUserMarketConnectPersonaDetails] = useState([]);
    const [userLoanReadinessPersonaDetails, setUserLoanReadinessPersonaDetails] = useState([]);
    const [userDigitalEanblementPersonaDetails, setUserDigitalEnablementPersonaDetails] = useState([]);
    const [userTestimonials, setUserTestimonials] = useState([]);

    const [groupKnowledgeAlreadyFilledPersonaInstanceId, setGroupKnowledgeAlreadyFilledPersonaInstanceId] = useState([]);
    const [expertConsiltAlreadyFilledPersonaInstanceId, setExpertConsiltAlreadyFilledPersonaInstanceId] = useState([]);
    const [marketConnectAlreadyFilledPersonaInstanceId, setMarketConnectAlreadyFilledPersonaInstanceId] = useState([]);
    const [complianceAlreadyFilledPersonaInstanceId, setComplianceAlreadyFilledPersonaInstanceId] = useState([]);
    const [loanReadinessAlreadyFilledPersonaInstanceId, setLoanReadineddAlreadyFilledPersonaInstanceId] = useState([]);
    const [digitalEnablementAlreadyFilledPersonaInstanceId, setDigitalEnablementAlreadyFilledPersonaInstanceId] = useState([]);

    const [isPersonaLoading, setIsPersonaLoading] = useState(false);

    const [allUserPersonaDetailGeneratedFile, setAllUserPersonaDetailGeneratedFile] = useState(null);

    const [userPersonaDetailFile, setUserPersonaDetailFile] = useState(null);

    const getUserPersonaDetails = async (mob) => {
        try {
            if (mob) {
                setIsPersonaLoading(true)
                const result = await api.jpmcThreeSixtyDegreeViewGetPersonaDetails(mob);
                console.log(result, ">>>>>result of getUserPersonaDetails");

                const isResult = result && result.data && result.data.data;
                console.log(isResult, ">>>>>isResult getUserPersonaDetails");

                if (isResult) {
                    setUserPersonaDetailsAllResources(result.data.data);

                    const {
                        data: {
                            ["Market Connect"]: marketConnect,
                            ["Compliance"]: compliance,
                            ["Group knowledge session"]: groupKnowledgeSession,
                            ["Business Loan Readiness Program"]: businessLoanReadinessProgram,
                            ["Digital Enablement"]: digitalSocialMediaManagement,
                            ["Expert Consultation"]: expertConsultation,
                            ["Testimonials"]: testiMonials
                        }
                    } = result.data

                    console.log(marketConnect, ">>>>Market_Connect");
                    setUserMarketConnectPersonaDetails(marketConnect)
                    const alreadyFIlledMarketConnect = marketConnect?.reduce((acc, curr) => {
                        const { nResourceInstanceId } = curr;
                        if (!acc.includes(nResourceInstanceId)) {
                            acc.push(nResourceInstanceId)
                        }
                        return acc;
                    }, [])
                    setMarketConnectAlreadyFilledPersonaInstanceId(alreadyFIlledMarketConnect)

                    console.log(compliance, ">>>>compliance");
                    setUserCompliancePersonaDetails(compliance)
                    const alreadyFIlledCompliance = compliance?.reduce((acc, curr) => {
                        const { nResourceInstanceId } = curr;
                        if (!acc.includes(nResourceInstanceId)) {
                            acc.push(nResourceInstanceId)
                        }
                        return acc;
                    }, [])
                    setComplianceAlreadyFilledPersonaInstanceId(alreadyFIlledCompliance)

                    console.log(groupKnowledgeSession, ">>>>groupKnowledgeSession");
                    setUserGroupKnowledgeSessionPersonaDetails(groupKnowledgeSession)
                    const alreadyFIlledPersonaGroupKnowledge = groupKnowledgeSession?.reduce((acc, curr) => {
                        const { nResourceInstanceId } = curr;
                        if (!acc.includes(nResourceInstanceId)) {
                            acc.push(nResourceInstanceId)
                        }
                        return acc;
                    }, [])
                    setGroupKnowledgeAlreadyFilledPersonaInstanceId(alreadyFIlledPersonaGroupKnowledge)

                    console.log(expertConsultation, ">>>>>expertConsultation");
                    setUserExptConsultPersonaDetails(expertConsultation)
                    const alreadyFIlledPersonaExpertConsult = expertConsultation?.reduce((acc, curr) => {
                        const { nResourceInstanceId } = curr;
                        if (!acc.includes(nResourceInstanceId)) {
                            acc.push(nResourceInstanceId)
                        }
                        return acc;
                    }, [])
                    setExpertConsiltAlreadyFilledPersonaInstanceId(alreadyFIlledPersonaExpertConsult)

                    console.log(businessLoanReadinessProgram, ">>>>Business_Loan_Readiness_Program");
                    setUserLoanReadinessPersonaDetails(businessLoanReadinessProgram);
                    setUserDigitalEnablementPersonaDetails(digitalSocialMediaManagement)
                     const alreadyFIlledPersonaDigitalEnablement = digitalSocialMediaManagement?.reduce((acc, curr) => {
                        const { nResourceInstanceId } = curr;
                        if (!acc.includes(nResourceInstanceId)) {
                            acc.push(nResourceInstanceId)
                        }
                        return acc;
                    }, [])
                    setDigitalEnablementAlreadyFilledPersonaInstanceId(alreadyFIlledPersonaDigitalEnablement)
                    const alreadyFIlledPersonaLoanReadiness = businessLoanReadinessProgram?.reduce((acc, curr) => {
                        const { nResourceInstanceId } = curr;
                        if (!acc.includes(nResourceInstanceId)) {
                            acc.push(nResourceInstanceId)
                        }
                        return acc;
                    }, [])
                    setLoanReadineddAlreadyFilledPersonaInstanceId(alreadyFIlledPersonaLoanReadiness)

                    if (testiMonials) {
                        console.log(testiMonials, ">>>>>testiMonials");
                        const lastAddedTestimonial = testiMonials[testiMonials.length - 1]
                        console.log(lastAddedTestimonial, ">>>>lastAddedTestimonial");
                        setUserTestimonials(lastAddedTestimonial)
                    } else {
                        setUserTestimonials({})
                    }

                    setIsPersonaLoading(false)
                }
            } else {
                throw new Error("Failed to get user resource count")
            }
        } catch (err) {
            console.error(err.message)
            setIsPersonaLoading(false)
        }
    }

    const handleSubmitPersonaDetails = async (formData) => {
        let payload = {
            "nUserId": userProfileDetail[0].nUserId,
            "sMobile": userProfileDetail[0].sMobile,
            ...formData
        }

        // console.log(payload, ">>>>payload");

        try {
            setIsPersonaLoading(true)
            let saveData = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload)
            if (saveData) {
                toast(String("Data saved successfully"), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                setIsPersonaLoading(false);
                getUserPersonaDetails(userProfileDetail[0].sMobile);
                setSelectedResourceInstanceId(null);
                setIsPersonaFormOpen(false);
            }
        } catch (err) {
            console.log(err.message)
            toast(String("Error adding market connect persona"), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setIsPersonaLoading(false);
        }
    }

      const handleSubmitDigitalPersonaDetails = async (formData, nResourceInstanceId) => {

        const payload = {
            nResourceInstanceId,
            nUserId: userProfileDetail[0].nUserId,
            sMobile: userProfileDetail[0].sMobile,
            ...formData
        };

        try {
            setIsPersonaLoading(true)
            let saveData = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload)
            if (saveData) {
                toast(String("Data saved successfully"), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                setIsPersonaLoading(false);
                getUserPersonaDetails(userProfileDetail[0].sMobile);
                setSelectedResourceInstanceId(null);
                setIsPersonaFormOpen(false);
            }
        } catch (err) {
            console.log(err.message)
            toast(String("Error adding market connect persona"), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setIsPersonaLoading(false);
        }
    }

    const addResourcesDetails = (tabId, instanceId) => {
        setNewTab(tabId)
        setIsPersonaFormOpen(true);
        setSelectedResourceInstanceId(instanceId)
        setShowNewSection(true);
    }

    const handleSetShowNewSection = () => {
        setShowNewSection(!showNewSection);
        setSelectedResourceInstanceId(null);
        setIsPersonaFormOpen(false);
        // setNewTab();
    }

    const downloadUserPersonaDetails = async (mobile) => {
        try {
            //   console.log(userProfileDetail[0]["sMobile"], ">>>>>>userDetail[0] ka in download single persona");

            let userDataDetails = await api.jpmcThreeSixtyDegreeViewUserPersonaDetailsDownload(mobile)
            console.log(userDataDetails, ">>>>>userDataDetails in download single file api call");

            if (userDataDetails) {
                setUserPersonaDetailFile(userDataDetails.data.generated_file)
            } else {
                setUserPersonaDetailFile(null)
            }
        } catch (err) {
            console.log(`Error donloading user persona details`);
            setUserPersonaDetailFile(null)
            toast(String(`err.message`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
    }

    // for resources tabs
    const handleTabChange = (event, newValue) => {
        console.log(newValue, ">>>>>handleTabChange");

        setTab(newValue)
    };

    // for persona details section tab
    const handleNewTabChange = (event, newValue) => {

        setNewTab(newValue)
        setSelectedResourceInstanceId(null);

        if (newValue == newTab) {
            setIsFormOpen(!isFormOpen)
        }
    };

    const handleFormCancel = () => {
        setIsPersonaFormOpen(false);
        setSelectedResourceInstanceId(null);
    }

    const getAllUserPersonaFile = async () => {
        try {
            let allUserPersonaGeneratedFile = await api.jpmcThreeSixtyDegreeViewUserAllPersonaDetailsDownload();


            if (allUserPersonaGeneratedFile?.data?.generated_file) {
                console.log(">>>entered download if");
                setAllUserPersonaDetailGeneratedFile(allUserPersonaGeneratedFile.data.generated_file)
            }
        } catch (err) {
            console.log(`Error getting persona file`)
        }
    }

    const handlePersonaFormOpen = () => {
        setIsFormOpen(!isFormOpen)
    }

    const handleUpdatePersonaDetail = async (data) => {
        let payload = {
            "nUserId": userProfileDetail[0].nUserId,
            "sMobile": userProfileDetail[0].sMobile,
            ...data
        }

        setIsPersonaLoading(true);
        try {
            let res = await api.updatePersonaDetail(payload);
            if (res) {
                getUserPersonaDetails(userProfileDetail[0].sMobile);
                setSelectedResourceInstanceId(null);
                setIsFormOpen(false);
                // setIsPersonaLoading(false)
            } else {
                setIsPersonaLoading(false);
            }
        } catch (err) {
            console.error(`Error updating persona details`)
            setIsPersonaLoading(false)
        }
    }


    return (
        <div style={{ justifyContent: "center" }}>

            <div className="col-12 lpm-filter-section conv-pl40 conv-pr40 conv-fixeds-headerss">
                <div className="row conv-mt20 conv-pl20">
                    <div className="col-12">
                        <div className="conv-pr5 conv-mr15  conv-align-self-center conv-float-left">
                            <div className="">
                                {
                                    allUserPersonaDetailGeneratedFile ? (
                                        <button
                                            className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
                                            style={{ marginLeft: "30px" }}
                                        >
                                            <a href={`${allUserPersonaDetailGeneratedFile}`} style={{ color: "#76287C", textDecoration: "none" }}>
                                                All Persona Download
                                            </a>
                                        </button>

                                    ) : (
                                        <button
                                            disabled={true}
                                            className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
                                            style={{ marginLeft: "30px" }}
                                        >

                                            All Persona Download
                                        </button>
                                    )
                                }

                                <button
                                    className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
                                    onClick={onSearchClicked}>
                                    Search
                                </button>
                                <input
                                    type="text"
                                    className="conv-float-right form-control conv-h250rem search-input "
                                    placeholder="Search"
                                    onChange={handleSearchInputChange}
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                            onSearchClicked();
                                        }
                                    }}
                                    //autoComplete={false}
                                    value={searchTerm}
                                    name="searchTerm"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {
                    userProfileDetail?.length > 0 ?
                        (
                            <>
                                <div className="conv-ml20 conv-mt15">Showing Results For : <span style={{ fontWeight: "bold" }}> {searchTerm ? searchTerm : userProfileDetail[0]["sMobile"]}</span> </div>
                            </>
                        ) :
                        (

                            <span className="conv-ml20 conv-mt15">No data to display</span>

                        )
                }
            </div>

            <div style={{ marginTop: "100px" }} className={`${isLoading && "set-opacity"}`}>
                {isLoading && <Spinner className="center-screen" />}
                {
                    userProfileDetail && <UserDetailContainer
                        userDetail={userProfileDetail}
                        openUserDetailModal={openUserDetailModal}
                        addedTestimonials={addedTestimonials}
                        getUserPersonaDetails={getUserPersonaDetails}
                        isPersonaLoading={isPersonaLoading}
                        hasJpmcAddEditPower={hasJpmcAddEditPower}
                        getUserTestimonial={getUserTestimonial}
                    />
                }

            </div>



            {/* Profile Page, if have to render on click of user profile-  selectedUser && showModal && <JpmcThreeSixtyDegreeModalProfilePage */}

            {
                // userProfileDetail.length > 0 &&
                userProfileDetail.length > 0  && (resourcesDetails?.KnowledgeSessions?.length > 0 || resourcesDetails?.ExpertConsultations?.length > 0 || resourcesDetails?.MarketOpportunities?.length > 0 || resourcesDetails?.Compliances?.length > 0 || resourcesDetails?.LoanReadiness?.length > 0 || resourcesDetails?.Deigital?.length > 0) &&
                <JpmcThreeSixtyDegreeModalProfilePage
                    open={showModal}
                    onClose={() => setShowModal(false)}
                    userData={selectedUser}
                    userDetail={userProfileDetail}
                    userResourcesCount={userResourcesCount}
                    resourcesDetails={resourcesDetails}

                    userGroupKnowledgeSesssionPersonaDetails={userGroupKnowledgeSesssionPersonaDetails}
                    userExptConsultationPersonaDetails={userExptConsultationPersonaDetails}
                    userCompliancePersonalDetails={userCompliancePersonalDetails}
                    userMarketConnectPersonaDetails={userMarketConnectPersonaDetails}
                    userLoanReadinessPersonaDetails={userLoanReadinessPersonaDetails}
                    userDigitalEanblementPersonaDetails={userDigitalEanblementPersonaDetails}

                    groupKnowledgeAlreadyFilledPersonaInstanceId={groupKnowledgeAlreadyFilledPersonaInstanceId}
                    expertConsiltAlreadyFilledPersonaInstanceId={expertConsiltAlreadyFilledPersonaInstanceId}
                    marketConnectAlreadyFilledPersonaInstanceId={marketConnectAlreadyFilledPersonaInstanceId}
                    complianceAlreadyFilledPersonaInstanceId={complianceAlreadyFilledPersonaInstanceId}
                    loanReadinessAlreadyFilledPersonaInstanceId={loanReadinessAlreadyFilledPersonaInstanceId}
                    digitalEnablementAlreadyFilledPersonaInstanceId={digitalEnablementAlreadyFilledPersonaInstanceId}


                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    handleSubmitDigitalPersonaDetails={handleSubmitDigitalPersonaDetails}
                    isPersonaLoading={isPersonaLoading}

                    addResourcesDetails={addResourcesDetails}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    showNewSection={showNewSection}
                    handleSetShowNewSection={handleSetShowNewSection}
                    newTab={newTab}
                    setNewTab={setNewTab}

                    tab={tab}

                    handleTabChange={handleTabChange}
                    handleNewTabChange={handleNewTabChange}

                    handleFormCancel={handleFormCancel}

                    userPersonaDetailFile={userPersonaDetailFile}

                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}

                    uniqueGroupKnowledgeInstanceId={uniqueGroupKnowledgeInstanceId}
                    uniqueExpertConsultInstanceId={uniqueExpertConsultInstanceId}
                    uniqueMarketOppInstanceId={uniqueMarketOppInstanceId}
                    uniqueComplianceInstanceId={uniqueComplianceInstanceId}
                    uniqueLoandReadinessInstanceId={uniqueLoandReadinessInstanceId}
                    uniqueDigitalEnablementInstanceId={uniqueDigitalEnablementInstanceId}
                    digitalEnablementInstances={digitalEnablementInstances}

                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                />
            }
        </div>
    );
}